import React, { FC } from 'react';
import './AnalysisBoxColorHeader.less';
import moment from 'moment/moment';
import i18n from '../../../common/i18n';
import clsx from 'clsx';
import { SportIconNui } from '../../../icons/SportIconNui';

export const AnalysisBoxColorHeader: FC<{ bet: any; expirationDate: any; tournamentName: any }> = ({
    bet,
    expirationDate,
    tournamentName
}) => {
    const home = bet?.participants[0];
    const away = bet?.participants[1];
    const opponentCss = 'flex-1 fs-14 self-center';
    return (
        <div className={clsx(`bg-${bet?.sportId} flex-center flex-col color-info-box`)}>
            <SportIconNui sportId={bet?.sportId} className={'c-white mt-15'} />
            {expirationDate && (
                <span className="fade-out-lines-white flex-center flex-1 c-white fs-12 opacity-50">
                    {formatExpirationDate(expirationDate)}
                </span>
            )}
            <div className="analysis-bs flex full-width c-white text-center f-condensed text-extra-bold px-20">
                <span className={opponentCss}>{home}</span>
                {away && (
                    <>
                        <span className="fs-16 mx-20 opacity-50 self-center">VS</span>
                        <span className={opponentCss}>{away}</span>
                    </>
                )}
            </div>
            <span className="flex-center flex-1 c-white fs-12 opacity-50">{tournamentName}</span>
        </div>
    );
};

export const formatExpirationDate = matchExpirationDate => {
    const startOfToday = moment().startOf('day');
    const endOfToday = moment().endOf('day');
    const endOfTomorrow = moment()
        .add(1, 'days')
        .endOf('day');
    const matchStart = moment(matchExpirationDate);
    const expirationTime = matchStart.format('HH:mm');
    const expirationDate = matchStart.format('DD.MM.YYYY - HH:mm');
    const isPlayingToday = matchStart.isBetween(startOfToday, endOfToday);
    const isPlayingTomorrow = matchStart.isBetween(endOfToday, endOfTomorrow);

    return isPlayingToday
        ? i18n('betbook.analysis.expiration.today') + ' ' + expirationTime
        : isPlayingTomorrow
        ? i18n('betbook.analysis.expiration.tomorrow') + ' ' + expirationTime
        : expirationDate;
};
